<mat-card class="wrapper-product-card-small">
  <div class="header-row"></div>
  <div class="wrapper-content">
    <div class="wrapper-image">
      <ngx-skeleton-loader
        [theme]="{height: '75px', width: '75px', 'border-radius':'0'}"
        appearance="circle"
      ></ngx-skeleton-loader>
    </div>
    <div class="wrapper-content">
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
      <div class="wrapper-attributes">
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</mat-card>
